<div id="fachgebiete" class="page-wrapper">

	<app-menu [activeMenuIndex]="6">
	</app-menu>

	<!--<div class="subheader-bar-wrapper">
		<div class="subheader-content">
			<a href="https://www.lsd-diagnostik-partner.de/" target="_blank">
				<div class="subheader-content-text">
					Ihr kostenfreies Testset!
				</div>
			</a>
		</div>
	</div>-->

	<div class="title-wrapper">
    <div class="m-t-30 img-header">
      <img src="/assets/img/template/02-kardiologie/herz-header.png" />
    </div>
		<h1>
			Kardiologie
		</h1>
		<div class="title-description">
      <ul class="bullet-kardiologie">
        <li>Jeder zweite Morbus Fabry-Patient stirbt an kardiovaskulären Komplikationen.<sup class="info-section-text-ref">1</sup></li>
        <li>Eine kardiale Beteiligung liegt bei ca. 60% der Fabry-Patienten vor.<sup class="info-section-text-ref">2</sup></li>
        <li>Die Prävalenz kardialer Symptome steigt mit dem Alter der Patienten.<sup class="info-section-text-ref">3</sup></li>
        <li>Typische Auffälligkeiten der Herzstruktur und -funktion lassen sich mit verschiedenen bildgebenden Verfahren darstellen. Besonders häufig: <a href="fachgebiete/kardiologie#section-1" class="color-kardiologie"><strong>linksventrikuläre Hypertrophie (LVH) ≥ 12 mm</strong></a> ohne/mit Hypertonie.</li>
      </ul>
		</div>
	</div>

	<div class="info-section fullwidth info-ribbon with-video-float color-white bgcolor-kardiologie">
    <div class="ribbon-left"><img src="/assets/img/template/02-kardiologie/dreieck-1.png"></div>
    <div class="info-section-title">
			Wann sollte in der Kardiologie an Morbus Fabry gedacht werden?
		</div>
    <p class="text-center">
      Das erfahren Sie in dem Expertenvideo<br>
      mit Prof. Dr. Fabian Knebel, Berlin.
		</p>
    <div class="video-float">
      <iframe src="https://www.youtube.com/embed/36EinEUEoiY" class="kardiologie" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
	</div>

	<div class="info-section m-t-30 p-t-20 p-b-30 fullwidth info-ribbon color-white bgcolor-kardiologie">
    <div class="ribbon-center"><img src="/assets/img/template/02-kardiologie/dreieck-2.png"></div>
    <div class="wrapper-center">
      <div class="info-section-title">
        Linksventrikuläre Hypertrophie
      </div>
      <p class="text-center">
          Bis zu 4 % der Patienten mit idiopathischer LVH sind an Morbus Fabry<br> erkrankt.<sup class="info-section-text-ref">5–7</sup><br>
          <br>
          Daher lohnt sich ein konsequentes Screening auf Morbus Fabry bei<br>
          sonst nicht erklärbarer kardialer Hypertrophie.
      </p>
    </div>
	</div>

	<div class="info-section m-b-0 m-t-50">
    <div class="wrapper-half-center m-b-40">
      <div class="info-section-title">
        Hypertrophe Kardiomyopathie
      </div>
      <p class="text-center">
        Eine hypertrophe Kardiomyopathie
        (HCM) tritt <strong>sehr häufig</strong> bei Morbus Fabry
        auf. Sie wird durch das Vorhandensein
        einer <strong>erhöhten LV-Wandstärke</strong>
        definiert, die nicht nur durch abnormale
        Belastungen erklärt werden kann.<sup class="info-section-text-ref">8</sup> Im
        fortgeschrittenen Stadium der
        Kardiomyopathie kommt es oft auch zu
        einer Hypertrophie des rechten
        Ventrikels.<sup class="info-section-text-ref">8</sup>
      </p>
    </div>
    <div class="d-lg h-md">
      <div class="info-section-image m-b-0">
        <img src="/assets/img/template/02-kardiologie/herz@2x.png" />
      </div>
      <div class="text-em margin-center text-center">
        Abdruck der Fotografien mit freundlicher Genehmigung von Prof. Dr. Christoph Kampmann, Mainz
      </div>
    </div>
    <div class="h-lg d-md">
      <div class="info-section-2columns">
        <div class="info-section-column">
          <div class="info-section-image m-b-0 text-center">
            <img src="/assets/img/template/02-kardiologie/herz-1@2x.png" />
          </div>
        </div>
        <div class="info-section-column">
          <div class="info-section-image m-b-0 text-center">
            <img src="/assets/img/template/02-kardiologie/herz-2@2x.png" />
          </div>
        </div>
        <div class="text-em margin-center text-center">
          Abdruck der Fotografien mit freundlicher Genehmigung von Prof. Dr. Christoph Kampmann, Mainz
        </div>
      </div>
    </div>
    <div class="wrapper-half-center m-t-40">
      <ul class="bullet-kardiologie text-center">
        <li>Linksventrikuläre Wandstärken ≥ 15 mm können als pathologisch angesehen werden. Einige
          HCM-Erkrankungen verursachen jedoch geringere Wandverdickungen (≥ 13 mm).<sup class="info-section-text-ref">8</sup></li>
        <li>In einigen Screenings wurde bei LV-Wandstärken ab 13 mm Morbus Fabry in Betracht gezogen.<sup class="info-section-text-ref">6,10</sup></li>
        <li>An eine kardiale Amyloidose sollte u. a. gedacht werden bei einer konzentrischen
          Wandverdickung ≥ 12 mm.<sup class="info-section-text-ref">9</sup></li>
      </ul>
      <a id="section-1"></a>
      <div class="info-section-image text-center m-t-50 m-b-50">
        <img src="/assets/img/template/02-kardiologie/achtung.png" />
      </div>
      <p class="text-center">
        Bei Vorliegen einer LVH mit Wanddicken ab 12 mm wird der Beginn einer Fabry-spezifischen Therapie dringend empfohlen.<sup class="info-section-text-ref">11</sup>
      </p>
    </div>
  </div>

  <div class="info-section m-t-50 m-b-30">
    <div class="info-section-table">
      <div class="title-kardiologie bgcolor-kardiologie text-center color-white">
        <strong>LVH ≥ 12 mm</strong><br>
        mit/ohne Hypertonie/Dyspnoe
      </div>
      <div class="info kardiologie">
        <div class="text-center color-kardiologie">
          <strong>Fragen Sie Ihren Patienten:</strong>
        </div>
        <ul class="bullet-kardiologie text-center">
          <li>Brennende Schmerzen in Händen/Füßen?</li>
          <li>Vermindertes Schwitzen?</li>
          <li>Magen-Darm-Beschwerden?</li>
          <li>Kleine rote Flecken auf der Haut?</li>
          <li>Nierenerkrankung bekannt?</li>
          <li>Schlaganfall/TIA?</li>
          <li>Positive Familienanamnese?</li>
        </ul>
      </div>
      <div class="title-kardiologie bgcolor-kardiologie text-center color-white">
        Mindestens eine Frage mit <div class="circle color-kardiologie">JA</div> <br>
        beantwortet?
      </div>
      <div class="info kardiologie">
        <div class="text-center color-kardiologie m-b-30">
          <strong>Verdacht auf Morbus Fabry</strong><br>
          Sie haben einen Verdacht?<br>
          <br>
          <a href="https://www.lsd-diagnostik-partner.de" target="_blank" class="info-section-button color-kardiologie info-section-button-1">
            Testen Sie jetzt! →
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="info-section m-t-0 m-b-0">
    <div class="wrapper-center">
      <div class="separator kardiologie"></div>
      <div class="info-section-title">
        Kardiale Diagnostik
      </div>
      <p class="text-center">
        Auffälligkeiten im Elektrokardiogramm bei Morbus Fabry
      </p>
    </div>
  </div>

  <div class="d-lg h-md">
    <div class="info-section m-t-10">
    <div class="info-section-image text-center m-t-30 m-b-40">
      <img src="/assets/img/template/02-kardiologie/kardiale-diagnostik-1.png" />
    </div>
    <div class="wrapper-half-center text-center">
      Das EKG zeigt <strong>Störungen im Erregungsleitungssystem.</strong> Abweichungen vom Normalverlauf in bestimmten Abschnitten weisen auf mögliche Ursachen hin.
    </div>
    </div>
  </div>
  <div class="h-lg d-md">
    <div class="info-section m-t-10">
    <div class="info-section-2columns">
      <div class="info-section-column">
        <div class="info-section-image text-center m-b-0">
          <img src="/assets/img/template/02-kardiologie/kardiale-diagnostik-1-a.png" />
        </div>
      </div>
      <p class="text-center m-b-30">
        Das EKG zeigt <strong>Störungen im Erregungsleitungssystem.</strong> Abweichungen vom Normalverlauf in bestimmten Abschnitten weisen auf mögliche Ursachen hin.
      </p>
      <div class="info-section-column">
        <div class="info-section-image text-center">
          <img src="/assets/img/template/02-kardiologie/kardiale-diagnostik-1-b.png" />
        </div>
      </div>
    </div>
    </div>
  </div>

  <div class="d-lg h-md">
    <div class="info-section-image m-t-30 m-b-0">
      <a href="referenzen#fachgebiete">
        <img src="/assets/img/template/02-kardiologie/kardiale-diagnostik-2.png" />
      </a>
    </div>
  </div>
  <div class="h-lg d-md">
    <div class="info-section-2columns">
      <div class="info-section-column">
        <div class="info-section-image m-b-0">
          <a href="referenzen#fachgebiete">
            <img src="/assets/img/template/02-kardiologie/kardiale-diagnostik-2a.png" />
          </a>
        </div>
      </div>
      <div class="info-section-column m-t-10 m-b-10">
        <div class="text-center" style="color: #027CC3"><strong>und/oder</strong></div>
      </div>
      <div class="info-section-column">
        <div class="info-section-image m-b-0">
          <a href="referenzen#fachgebiete">
            <img src="/assets/img/template/02-kardiologie/kardiale-diagnostik-2b.png" />
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="info-section m-b-0 m-t-50">
    <div class="separator kardiologie"></div>
    <div class="info-section-title m-b-0">
      Weitere typische Veränderungen im EKG
    </div>
  </div>

  <div class="info-section fullwidth color-white bgcolor-kardiologie">
    <div class="info-section-image text-center">
      <img src="/assets/img/template/02-kardiologie/herz-icon.png" />
    </div>
    <ul class="bullet-white text-center">
      <li><strong>Verkürztes PR-Intervall<sup class="info-section-text-ref">12</sup></strong></li>
      <li><strong>Verkürzter QRS-Komplex<sup class="info-section-text-ref">12</sup></strong></li>
      <li><strong>QTC-Zeit-Verlängerung<sup class="info-section-text-ref">13</sup></strong></li>
      <li><strong>AV-Blockierungen<sup class="info-section-text-ref">12</sup></strong></li>
      <li><strong>Erhöhter Sokolow-Index<sup class="info-section-text-ref">14</sup></strong></li>
    </ul>
	</div>

  <div class="info-section m-t-0 m-b-0">
    <div class="wrapper-half-center">
      <p class="text-center">
        Typische Manifestation bei jungen männlichen Patienten ist das sogenannte Roboterherz mit
        reduzierter <strong>Herzfrequenzvariabilität</strong>, oft in Kombination mit Hypo- oder Anhidrose.
        Supraventrikuläre Runs und Vorhofflimmern nimmt der Patient bereits als <strong>Herzrasen</strong> wahr,
        zusätzlich treten Extrasystolen im Rahmen von Kardiomyopathien auf. Daher sollten bei
        Verdacht routinemäßig EKG- und <strong>Langzeit-EKG</strong>-Untersuchungen durchgeführt werden bzw.
        sollte ein <strong>Eventrecorder</strong> zum Einsatz kommen.
      </p>
    </div>
  </div>

  <div class="info-section m-t-0 m-b-0">
    <div class="wrapper-half-title-center">
      <div class="separator kardiologie"></div>
      <div class="info-section-title m-b-0">
        Kardiale Manifestationen im<br>
        fortgeschrittenen Stadium<br>
        von Morbus Fabry
      </div>
    </div>
  </div>

  <div class="info-section p-t-0 p-b-40 fullwidth info-ribbon bgcolor-grey">
    <div class="ribbon-center"><img src="/assets/img/template/02-kardiologie/dreieck-2.png"></div>
    <div class="wrapper-half-center">
      <ul class="bullet-kardiologie text-center">
        <li>Erregungsrückbildungsstörungen, insb. in V5/V6<sup class="info-section-text-ref">15</sup></li>
        <li>Supraventrikuläre brady- oder tachykarde Rhythmusstörungen</li>
        <li>Vorhofflimmern</li>
        <li>Ventrikuläre Tachykardie ist potenziell lebensgefährlich und ein Zeichen für eine Spätstadium-Kardiomyopathie</li>
      </ul>
    </div>
	</div>

  <div class="info-section m-b-0">
    <div class="wrapper-half-title-center">
      <div class="separator kardiologie"></div>
      <div class="info-section-title">
        Auffälligkeiten in der
        Echokardiographie bei
        Morbus Fabry:<br>
        Differentialdiagnostische
        Herausforderung
      </div>
    </div>
    <div class="wrapper-half-center">
      <p class="text-center">
        Differentialdiagnostisch sind u. a. die
        <strong>kardiale Amyloidose</strong> oder andere
        genetisch bedingte Kardiomyopathien,
        z. B. die <strong>Friedreich-Kardiomyopathie,</strong>
        von Morbus Fabry-bedingten
        Myopathien zu unterscheiden. Das
        Echokardiogramm in Kombination mit
        einer <strong>Strain-Analyse</strong> macht die
        Unterschiede deutlich:
      </p>
      <div class="info-section-subtitle2 text-center m-t-40 m-b-10">
        <strong>Morbus Fabry</strong>
      </div>
      <div class="info-section-image text-center m-b-30">
        <img src="/assets/img/template/02-kardiologie/morbus-fabry.png" />
        <div class="text-em margin-center text-center">
          Mit freundlicher Genehmigung von Prof. Dr. Frank Weidemann,
          Recklinghausen
        </div>
      </div>
      <ul class="bullet-kardiologie text-center">
        <li>Reduzierte Herzfunktion, insbesondere basal-lateral</li>
        <li>Reduzierte longitudinale Funktion</li>
        <li>Prominenter Papillarmuskel<sup class="info-section-text-ref">16</sup></li>
        <li>Erhöhte linksventrikuläre Wandstärken (≥ 13 mm)<sup class="info-section-text-ref">17</sup></li>
        <li>Häufig normale Ejektionsfraktion und diastolische Funktion<sup class="info-section-text-ref">18</sup></li>
        <li>Gestörte Klappenfunktion<sup class="info-section-text-ref">19</sup></li>
        <li>Typisches Muster in der Strain-Analyse<sup class="info-section-text-ref">20</sup></li>
        <li>Verminderter globaler Strain<sup class="info-section-text-ref">16</sup></li>
      </ul>
      <br>
      <div class="info-section-subtitle2 text-center m-t-30 m-b-10">
        <strong>Kardiale Amyloidose</strong>
      </div>
      <div class="info-section-image text-center">
        <img src="/assets/img/template/02-kardiologie/kardiale-amyloidose.png" />
        <div class="text-em margin-center text-center">
          Mit freundlicher Genehmigung von Prof. Dr. Frank Weidemann,
            Recklinghausen
        </div>
      </div>
      <p class="text-center">
        „Apical sparing“
        = erhaltene Herzfunktion (= Strain)
        nur in den apikalen Segmenten
      </p>
      <br>
      <div class="info-section-subtitle2 text-center m-t-30 m-b-10">
        <strong>Friedreich-Kardiomyopathie</strong>
      </div>
      <div class="info-section-image text-center">
        <img src="/assets/img/template/02-kardiologie/friedrich-kardiomyopathie.png" />
        <div class="text-em margin-center text-center">
          Mit freundlicher Genehmigung von Prof. Dr. Frank Weidemann,
            Recklinghausen
        </div>
      </div>
      <p class="text-center">
        Über lange Zeit erhaltene Herzfunktion in allen Segmenten
      </p>
    </div>
  </div>

  <div class="info-section m-t-0 m-b-0">
    <div class="wrapper-half-title-center">
      <div class="separator kardiologie"></div>
      <div class="info-section-title">
        Auffälligkeiten in der
        Magnetresonanztomographie
        bei Morbus Fabry
      </div>
    </div>
    <div class="wrapper-half-center">
      <p class="text-center">
        Die MRT erlaubt die Identifizierung einer
        <strong>Fibrose</strong> oftmals schon, bevor sie im Echo
        darstellbar ist. Wegen ihrer hohen
        Empfindlichkeit wird sie besonders zur
        <strong>Dokumentation des Baseline-Status</strong>
        zum Zeitpunkt der Diagnosestellung
        eingesetzt.
      </p>
    </div>
  </div>

  <div class="info-section m-t-0 m-b-30">
    <div class="wrapper-center">
      <div class="cols-2 p-t-20">
        <div class="col">
          <div class="info-section-block m-b-40">
          <div class="info-section-circle-center kardiologie">
            <div>
              <div class="title" style="font-family: 'OpenSans-Bold'">
                Frühe fibrotische<br>
                Veränderungen<br>
              </div>
              <div class="subtitle" style="font-family: 'OpenSans-Bold'">
                sind mit der MRT besser<br>
                nachweisbar als mit der<br>
                Echokardiographie:<br>
              </div>
              <div class="m-t-10">
                Daher ist sie besonders bei der<br>
                Baseline-Untersuchung im<br>
                Fabry-Zentrum angezeigt.
              </div>
            </div>
          </div>
          <div class="info-section-circle-center-badge kardiologie">
            <div>
              Wichtig!
            </div>
          </div>
          </div>
        </div>
        <div class="col">
          <p class="text-center">
            In einer multizentrischen,<br>
            internationalen, prospektiven,<br>
            diagnostischen <strong>Beobachtungsstudie</strong><br>
            wurde die diagnostische Aussagekraft<br>
            von <strong>Bildgebung und Biomarkern</strong> zur<br>
            frühzeitigen Erkennung einer kardialen<br>
            Beteiligung bei Morbus Fabry<br>
            untersucht.<sup class="info-section-text-ref">21</sup>
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="info-section m-t-50 p-b-40 fullwidth info-ribbon color-white bgcolor-kardiologie">
    <div class="ribbon-left"><img src="/assets/img/template/02-kardiologie/dreieck-1.png"></div>
    <div class="wrapper-center">
      <div class="info-section-subtitle2 text-center"><strong>Magnetresonanztomographie mit
        Late-Enhancement-Technik zur<br>
        Darstellung einer myokardialen
        „Replacement-Fibrose“</strong>
        <br><br>
      </div>
      <div class="info-section-image text-center">
        <img src="/assets/img/template/02-kardiologie/magnet.png" />
        <div class="text-em margin-center text-center">
          Mit freundlicher Genehmigung von Prof. Dr. Frank Weidemann,
            Recklinghausen
        </div>
      </div>
    </div>
    <div class="wrapper-half-center p-b-20">
      <ul class="bullet-white text-center">
        <li>Auffallend ist die typisch lokalisierte
          mid-myokardiale Fibrose in der
          inferolateralen Wand, die sich von dort
          aus in die mittleren Segmente ausbreitet
          (Zunahme ca. 1 ml/Jahr).<sup class="info-section-text-ref">21</sup></li>
        <li>Myokardiale Fibrose tritt bei Frauen oft
          noch vor einer Hypertrophie auf.<sup class="info-section-text-ref">21</sup></li>
        <li>Myokardiale Fibrose ist eine frühe
          Manifestation und zeigt eine klinisch
          relevante kardiale Beteiligung an.<sup class="info-section-text-ref">21</sup></li>
      </ul>
    </div>
    <div class="ribbon-right"><img src="/assets/img/template/02-kardiologie/dreieck-2.png"></div>
	</div>

  <div class="info-section m-b-0 m-t-50 m-b-40">
    <div class="wrapper-center">
      <div class="info-section-title">
        Verteilung der LGE-positiven<br> Segmente im LV<sup class="info-section-text-ref">21</sup>
      </div>
      <div class="info-section-image text-center">
        <img src="/assets/img/template/02-kardiologie/verteilung.png" />
      </div>
    </div>
    <div class="wrapper-half-center">
      <ul class="bullet-kardiologie text-center">
        <li>Die Anzahl der Patienten mit LGE im
          linken Ventrikel stieg im Verlauf von 1
          bzw. <br>2 Jahren von 18 (64 %) auf
          20 (71 %) an.<sup class="info-section-text-ref">21</sup></li>
        <li>LGE trat am häufigsten im <strong>basalen
          inferolateralen Segment</strong> auf und
          breitete sich von dort weiter aus.<sup class="info-section-text-ref">21</sup></li>
        <li>Im rechten Ventrikel wurde kein LGE
          gefunden.<sup class="info-section-text-ref">21</sup></li>
      </ul>
      <div class="text-em margin-center text-center">
        LGE: Late Gadolinium Enhancement; LV: linker Ventrikel.
      </div>
    </div>
  </div>

  <div class="info-section p-b-40 p-t-30 fullwidth info-ribbon color-white bgcolor-kardiologie">
    <div class="wrapper-half-center">
      <div class="info-section-subtitle2 text-center"><strong>T1-Mapping zur Differenzierung
        zwischen sarkomerischer HCM und
        Morbus Fabry als Ursache der LVH<sup class="info-section-text-ref">22,23</sup></strong>
        <br><br>
      </div>
    </div>
    <div class="wrapper-center">
      <div class="info-section-image text-center">
        <img src="/assets/img/template/02-kardiologie/t1-mapping.png" />
        <div class="text-em margin-center text-center">
          Mit freundlicher Genehmigung von PD Dr. Peter Nordbeck, Würzburg
        </div>
      </div>
    </div>
    <div class="wrapper-half-center m-t-30 m-b-30">
      <ul class="bullet-white text-center">
        <li>Erniedrigtes T1-Signal</li>
        <li>Im Spätstadium Normalisierung von T1</li>
        <li>Erniedrigte T1-Werte können Hinweis
          auf Fabry sein, daher ist eine weitere
          diagnostische Abklärung beim
          Spezialisten empfehlenswert<sup class="info-section-text-ref">23</sup></li>
      </ul>
    </div>
    <div class="ribbon-center"><img src="/assets/img/template/02-kardiologie/dreieck-2.png"></div>
	</div>

  <div class="info-section m-b-50">
    <div class="wrapper-half-center">
      <div class="separator kardiologie"></div>
      <div class="info-section-title">
        Biomarker: Kardiales Troponin
      </div>
      <p class="text-center">
        Die fortschreitende Myopathie wird von
        einer <strong>persistierenden Erhöhung</strong> der
        Troponin-Werte begleitet, insbesondere
        wenn bereits eine LVH vorliegt.<sup class="info-section-text-ref">24,25</sup>
      </p>
    </div>
    <div class="wrapper-half-title-center">
      <div class="separator kardiologie"></div>
      <div class="info-section-title">
        Verringerte Lebensqualität
        durch kardiale Symptome
        von Morbus Fabry<sup class="info-section-text-ref">26–28</sup>
      </div>
    </div>
    <div class="wrapper-half-center">
      <p class="text-center">
        Die Symptomlast von Morbus Fabry,
        besonders durch <a href="fachgebiete/neurologie#section-0" class="color-kardiologie"><strong>neuropathische
        Schmerzen</strong></a> und kardiale
        Manifestationen führt häufig dazu, dass
        Patienten weniger am Sozialleben
        teilnehmen und mehr Krankheitstage bei
        der Arbeit melden.
      </p>
    </div>
  </div>

  <div class="info-section m-b-0 p-b-10 m-t-0 p-t-0 fullwidth info-ribbon color-white bgcolor-kardiologie">
    <div class="wrapper-half-center">
      <p class="text-center"><strong>50 % der Patienten berichten</strong>, dass
        die kardialen Symptome das Sozial- und
        Familienleben und die Leistungsfähigkeit
        im Beruf beeinträchtigen.<sup class="info-section-text-ref">29,30</sup>
      </p>
    </div>
    <div class="wrapper-narrow-center">
      <div class="cols-2 p-t-20 bgcolor-white color-black">
        <div class="col">
          <div class="info-section-image">
            <img src="/assets/img/template/02-kardiologie/fatigue.png" />
          </div>
          <p><strong>Fatigue</strong></p>
        </div>
        <div class="col">
          <div class="info-section-image">
            <img src="/assets/img/template/02-kardiologie/kurzatmigkeit.png" />
          </div>
          <p><strong>Kurzatmigkeit</strong></p>
        </div>
        <div class="col">
          <div class="info-section-image">
            <img src="/assets/img/template/02-kardiologie/palpitationen.png" />
          </div>
          <p><strong>Palpitationen</strong></p>
        </div>
        <div class="col">
          <div class="info-section-image">
            <img src="/assets/img/template/02-kardiologie/angina-pectoris.png" />
          </div>
          <p><strong>Angina pectoris</strong></p>
        </div>
          <p class="text-center">
            Fatigue tritt vor allem bei <strong>Jugendlichen</strong><br>
            auf. Dies kann, selbst wenn weitere<br>
            Symptome noch nicht manifest sind, die<br>
            <strong>Lebensqualität</strong> der Heranwachsenden<br>
            erheblich einschränken.<sup class="info-section-text-ref">26</sup>
          </p>
      </div>
      <p class="text-center"><strong>Daher ist eine frühzeitige Diagnose
        entscheidend für den prognostischen
        Verlauf von Morbus Fabry.</strong>
      </p>
  </div>
	</div>

  <div class="info-section m-t-30 m-b-0">
    <div class="wrapper-center">
      <div class="separator kardiologie"></div>
      <div class="info-section-title">
        Was sind Therapieziele in der Kardiologie?
      </div>
    </div>
  </div>

  <div class="info-section m-t-0">
    <div class="info-section-block">
			<div class="info-section-circle-center kardiologie-inverted">
				<div class="title">
          <strong>
					  Die therapeutischen Ziele<br>
            sind abhängig vom<br>
            Stadium der Erkrankung<br>
            zum Zeitpunkt des<br>
            Therapiebeginns.<br>
          </strong>
				</div>
			</div>
    </div>
  </div>

  <div class="info-section m-t-0 m-b-50">
    <div class="wrapper-half-center">
      <p class="text-center">
        Die fortschreitende Einlagerung von
        Glycosphingolipiden kann eine
        <strong>zunehmende Myopathie</strong> und damit die
        Progression der kardialen Symptomatik
        verursachen. Je früher eine <a href="therapie" class="color-kardiologie"><strong>ursächliche
        Therapie</strong></a> begonnen werden kann, desto
        früher können <strong>Organschäden</strong> verzögert
        oder sogar verhindert werden.<sup class="info-section-text-ref">31,32</sup>
      </p>
    </div>
  </div>

  <div class="info-section p-b-40 m-t-0 fullwidth info-ribbon color-white bgcolor-kardiologie">
    <div class="ribbon-left-bottom"><img src="/assets/img/template/02-kardiologie/dreieck-2.png"></div>
    <div class="info-section-title">
      Erhalt der kardialen Struktur und Funktion
    </div>
    <div class="wrapper-half-center">
        <p class="text-center">Die Therapie strebt den Erhalt der kardialen Struktur und die Verhinderung der Progression einer LVH an.
        Funktionale Parameter wie LVEF, QRS-Zeit und Herzfrequenzvariabilität sollen normalisiert werden.
        Insgesamt erhofft man sich eine Besserung der Symptome oder zumindest ein Vorbeugen weiterer
        Verschlechterungen oder Komplikationen.
      </p>
    </div>
	</div>
  <div class="m-b-50"></div>


</div>

<app-footer>
</app-footer>

<style>
	/*.info-section-container {
		display: flex;
		flex-wrap: wrap;
		width: 1200px;
		margin-bottom: 120px;
	}
	@media only screen and (max-width: 768px) {
		.info-section-container {
			width: calc(100% + 64px);
			margin-bottom: 8px;
		}
	}*/
</style>
